import {isFunction} from "../../types/guards/isFunction";
import {Factory} from "../../types/common/functions/Factory";
import {isAuthInfo} from "../../../controllers/auth/isAuthInfo";
import {AnyFn} from "../../types/common/functions/AnyFn";

export function RestrictedAccess(adminTypes: string[], fallbackFn: Factory<unknown> = () => {
}): MethodDecorator {
    return (proto: any, prop: string | symbol, desc: PropertyDescriptor) => {
        const methodName = `@RestrictedAccess(${String(prop)})`;
        const FN = Symbol(`${methodName}.FN`);
        const RESTRICTED = Symbol(`${methodName}.BOUND`);

        delete desc.value;
        delete desc.writable;

        adminTypes = adminTypes.map(it => it.toUpperCase());

        proto[FN] = proto[prop];

        function getWithRestriction(this: any, fn: AnyFn) {
            const self = this;

            if (typeof self?.controllers?.auth?.getAuthInfo_ === 'function') {
                return function (...args: any) {
                    const authInfo = self.controllers.auth.getAuthInfo_();

                    if (isAuthInfo(authInfo)) {
                        const adminType = (authInfo.pccsStatus?.adminType ?? '').toUpperCase();
                        const adminTypesIncludes = adminTypes.includes(adminType);

                        const onBehalfOf = authInfo.pccsStatus?.onBehalfOf;
                        const isOnBehalfOf = adminTypes.includes('AA')
                            && adminType === 'SA'
                            && !!onBehalfOf;

                        const isAllowed = adminTypesIncludes
                            || isOnBehalfOf;

                        const msgSuffix = `method restricted to ${adminTypes.join(', ')} as ${adminType}${isOnBehalfOf ? ` which acts on behalf of ${onBehalfOf}` : ''}`;

                        if (isAllowed) {
                            console.info(`[AUTH] Executing ${msgSuffix}`)
                            return fn.apply(self, args);
                        } else {
                            console.info(`[AUTH] Executing fallback for ${msgSuffix}`)
                            return fallbackFn.apply(self, args);
                        }
                    }
                }
            }

            console.error(`[AUTH] Cannot use RestrictedAccess() decorator!`);

            return function (...args: any) {
                console.info(`[AUTH] Executing method restricted to ${adminTypes.join(', ')}`)
                return fn.apply(self, args);
            }
        }

        desc.get = function (this: typeof proto) {
            return this[RESTRICTED] ??= getWithRestriction.call(this, this[FN]);
        };

        desc.set = function (this: typeof proto, value: unknown) {
            delete this[RESTRICTED];

            this[RESTRICTED] = isFunction(value)
                ? getWithRestriction.call(this, value)
                : undefined;
        }
    };
}